import clsx from 'clsx';
import { oneOf, shape, string } from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import { Icon } from 'components';

const Tooltip = ({ id, content, icon = { name: 'circle-info', style: 'fad' }, className = '', placement = 'top' }) => {
  return (
    <>
      <ReactTooltip id={id} style={{ backgroundColor: 'rgb(0, 0, 0)', maxWidth: '200px' }} />

      <button
        type="button"
        className={clsx(className)}
        data-tooltip-id={id}
        data-tooltip-content={content}
        data-tooltip-place={placement}
        data-tooltip-class-name="tooltip"
      >
        <Icon name={icon?.name} iconStyle={icon.style} libraryIconProps={{ size: 'lg' }} />
      </button>
    </>
  );
};

Tooltip.propTypes = {
  id: string.isRequired,
  content: string.isRequired,
  className: string,
  icon: shape({
    name: string,
    style: string
  }),
  placement: oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end'
  ])
};

export default Tooltip;
